import React from 'react';
const DescriptionsContext = /*#__PURE__*/React.createContext({});
export default DescriptionsContext;